import { AppContextWrapper } from '../util/context';
import UTMContext from '../util/utm-context';
import { useRouteChange } from '../util/hooks';
import { GTMPageView } from '../util/googleTagManager';
import { setUpLocalStorage } from '../util/set-local-storage';

import '../styles/index.scss';
import { useEffect, useState } from 'react';
/* If in development mode, inject axe accessibility tools. */
if (typeof window !== 'undefined' && process.env.NODE_ENV !== 'production') {
    const ReactDOM = require('react-dom');
    const axe = require('@axe-core/react');

    axe(React, ReactDOM, 1000, {
        runOnly: ['best-practice', 'wcag2a', 'wcag2aa']
    });
}

function App({ Component, pageProps, err }) {




    /* Trigger a page view on in-app routing */
    useRouteChange(GTMPageView);

    /* Set initial state for utmStorage */
    const [utmStorageSet, setUtmStorage] = useState(false);




    
    useEffect(() => {
        /* hello! this side effect will only be called once, when the component first mounts */
        let timer = 0;
        let twoSecondScript = false;
        let thirtySecondScript = false;
        let increment = () => {
            timer = (timer % 360) + 1;
            if (timer >= 2 && !twoSecondScript) {
                twoSecondScript = true;
                let script1 = document.createElement('script');
                script1.src =
                    'https://pixel.mathtag.com/event/js?mt_id=1557003&mt_adid=247959&mt_exem=&mt_excl=&v1=&v2=&v3=&s1=&s2=&s3=';
                script1.async = true;
                script1.language = 'JavaScript1.1';
                document.getElementsByTagName('head')[0].appendChild(script1);
            }

            if (timer >= 2 && !thirtySecondScript) {
                thirtySecondScript = true;
                let script2 = document.createElement('script');
                script2.src =
                    'https://pixel.mathtag.com/event/js?mt_id=1557004&mt_adid=247959&mt_exem=&mt_excl=&v1=&v2=&v3=&s1=&s2=&s3=';
                script2.async = true;
                script2.language = 'JavaScript1.1';
                document.getElementsByTagName('head')[0].appendChild(script2);
            }
        };

       

        setInterval(increment, 1000);

        /**
        * Capture UTMs, referrer, etc. into localstorage
        * This only needs to run once on the first app render
        */
        setUpLocalStorage();
        setUtmStorage(true);



//All running experiment data save in cookie with this name.
const cookieName = 'experimentData';

// cookie regex pattern of vwo experiment
const combiRegex = /^_vis_opt_exp_([0-9]*)_combi$/i;
const splitRegex = /^_vis_opt_exp_([0-9]*)_split$/i;

// experiment type in vwo
const EXPERIMENTS_TEST_TYPE = {
    VISUAL_AB: 'VISUAL_AB',
    SPLIT_URL: 'SPLIT_URL',
};

//function to check whether the object is empty
const isEmpty = (obj) => {
    if (obj && typeof obj === 'object' && Object.keys(obj).length === 0) return true;
};

// Function to retrieve cookie value by name
const getCookie = (name) => {
    const cookies = document.cookie.split(';').map(cookie => cookie.trim().split('='));
    const cookie = cookies.find(cookie => cookie[0] === name);
    return cookie ? cookie[1] : null;
};

// Function to set cookie value
const setCookies = (name, value) => {
    const cookieValue = `${name}=${JSON.stringify(value) || []};`;
    const path = 'path=/;';
    const domain = 'domain=.enfusion.com;';

    // Set expiration time to 2 hours from now
    const expires = new Date(Date.now() + 2 * 60 * 60 * 1000).toUTCString();
    const expiration = `expires=${expires};`;
    const cookie = `${cookieValue} ${path} ${domain} ${expiration}`;

    document.cookie = cookie;
};

// find running experiments on page
const runningExperiments = () => {
    const result = [];
    const cookies = document.cookie.split(';').map(cookie => cookie.trim().split('='));
    for (let i = 0; i < cookies.length; i++) {
        let match;
        const cookie = cookies[i];
        if ((match = combiRegex.exec(cookie[0])) !== null) {
            result.push({ experimentId: match[1], variationId: cookie[1] });
        }
        if ((match = splitRegex.exec(cookie[0])) !== null) {
            result.push({ experimentId: match[1], variationId: cookie[1] });
        }
    }
    return result;
};

// check if experiment already saved in cookies
const isExperimentAlreadyExists = (currentExperiments, previousSavedExperiments) => {
    let previousExp = JSON.parse(previousSavedExperiments) || [];
    currentExperiments.forEach((experiment) => {
        const isExperimentExist = previousExp.find(exp => exp.experimentId === experiment.experimentId);
        if (!isExperimentExist) {
            previousExp.push(experiment);
        } else {
            const isVariationSame = isExperimentExist.variationId === experiment.variationId;
            if (!isVariationSame) previousExp.push(experiment);
        }
    })
    return previousExp;
};

// track all the vwo experiment running on page and set all the experiment data into the form page
const trackExperiment = () => {
    const experiments = runningExperiments();
    const experimentData = experiments.reduce((result, { experimentId, variationId }) => {
        const experimentsObject = JSON.parse(JSON.stringify(window._vwo_exp)) || {};
        const experiment = experimentsObject[experimentId] || {};

        if (!isEmpty(experiment)) {
            if (Object.values(EXPERIMENTS_TEST_TYPE).includes(experiment.type)) {
                const experimentName = experiment.name || '';
                const variationName = experiment.comb_n[variationId] || '';
                result.push({ experimentId, experimentName, variationId, variationName });
            }
        }

        return result;
    }, []);

    const existingCookieValue = getCookie(cookieName);
    
    if (existingCookieValue !== null) {
        const cookieValue = isExperimentAlreadyExists(experimentData, existingCookieValue);
        setCookies(cookieName, cookieValue);
    } else if (experimentData.length > 0) {
        setCookies(cookieName, experimentData);
    }
};

// Keep checking for VWO experiments until they become visible
const intervalId = setInterval(() => {
    if (window._vwo_exp && !isEmpty(window._vwo_exp) || {}) {
        trackExperiment();
    }
}, 2000);










//          /* Load VWO SmartCode */
if (typeof window !== 'undefined') {
    // Check if window is available (to avoid server-side rendering issues)
    const linkvwo = document.createElement('link');
    linkvwo.rel = 'preconnect';
    linkvwo.href = 'https://dev.visualwebsiteoptimizer.com';
    const scriptvwo = document.createElement('script');
    scriptvwo.id = 'vwoCode';
    scriptvwo.setAttribute('strategy', 'beforeInteractive');
    scriptvwo.innerHTML = `
        window._vwo_code || (function() {
            var account_id=856155,
            version=2.1,
            settings_tolerance=5000,
            hide_element='body',
            hide_element_style = 'opacity:0 !important;filter:alpha(opacity=0) !important;background:none !important', f=false,w=window,d=document,v=d.querySelector('#vwoCode'),cK='vwo'+account_id+'settings',cc={};try{var c=JSON.parse(localStorage.getItem('_vwo'+account_id+'config'));cc=c&&typeof c==='object'?c:{}}catch(e){}var stT=cc.stT==='session'?w.sessionStorage:w.localStorage;code={use_existing_jquery:function(){return typeof use_existing_jquery!=='undefined'?use_existing_jquery:undefined},library_tolerance:function(){return typeof library_tolerance!=='undefined'?library_tolerance:undefined},settings_tolerance:function(){return cc.sT||settings_tolerance},hide_element_style:function(){return'{'+(cc.hES||hide_element_style)+'}'},hide_element:function(){if(performance.getEntriesByName('first-contentful-paint')[0]){return''}return typeof cc.hE==='string'?cc.hE:hide_element},getVersion:function(){return version},finish:function(e){if(!f){f=true;var t=d.getElementById('_vis_opt_path_hides');if(t)t.parentNode.removeChild(t);if(e)(new Image).src='https://dev.visualwebsiteoptimizer.com/ee.gif?a='+account_id+e}},finished:function(){return f},addScript:function(e){var t=d.createElement('script');t.type='text/javascript';if(e.src){t.src=e.src}else{t.text=e.text}d.getElementsByTagName('head')[0].appendChild(t)},load:function(e,t){var i=this.getSettings(),n=d.createElement('script'),r=this;t=t||{};if(i){n.textContent=i;d.getElementsByTagName('head')[0].appendChild(n);if(!w.VWO||VWO.caE){stT.removeItem(cK);r.load(e)}}else{var o=new XMLHttpRequest;o.open('GET',e,true);o.withCredentials=!t.dSC;o.responseType=t.responseType||'text';o.onload=function(){if(t.onloadCb){return t.onloadCb(o,e)}if(o.status===200){w._vwo_code.addScript({text:o.responseText})}else{w._vwo_code.finish('&e=loading_failure:'+e)}};o.onerror=function(){if(t.onerrorCb){return t.onerrorCb(e)}w._vwo_code.finish('&e=loading_failure:'+e)};o.send()}},getSettings:function(){try{var e=stT.getItem(cK);if(!e){return}e=JSON.parse(e);if(Date.now()>e.e){stT.removeItem(cK);return}return e.s}catch(e){return}},init:function(){if(d.URL.indexOf('vwo_disable_')>-1)return;var e=this.settings_tolerance();w._vwo_settings_timer=setTimeout(function(){w._vwo_code.finish();stT.removeItem(cK)},e);var t;if(this.hide_element()!=='body'){t=d.createElement('style');var i=this.hide_element(),n=i?i+this.hide_element_style():'',r=d.getElementsByTagName('head')[0];t.setAttribute('id','_vis_opt_path_hides');v&&t.setAttribute('nonce',v.nonce);t.setAttribute('type','text/css');if(t.styleSheet)t.styleSheet.cssText=n;else t.appendChild(d.createTextNode(n));r.appendChild(t)}else{t=d.getElementsByTagName('head')[0];var n=d.createElement('div');n.style.cssText='z-index: 2147483647 !important;position: fixed !important;left: 0 !important;top: 0 !important;width: 100% !important;height: 100% !important;background: white !important;';n.setAttribute('id','_vis_opt_path_hides');n.classList.add('_vis_hide_layer');t.parentNode.insertBefore(n,t.nextSibling)}var o='https://dev.visualwebsiteoptimizer.com/j.php?a='+account_id+'&u='+encodeURIComponent(d.URL)+'&vn='+version;if(w.location.search.indexOf('_vwo_xhr')!==-1){this.addScript({src:o})}else{this.load(o+'&x=true')}}};w._vwo_code=code;code.init();})();
    (function(){
        var i=window;
        function t(){
            if(i._vwo_code){
                var e=t.hidingStyle=document.getElementById('_vis_opt_path_hides')||t.hidingStyle;
                if(!i._vwo_code.finished()&&!_vwo_code.libExecuted&&(!i.VWO||!VWO.dNR)){
                    if(!document.getElementById('_vis_opt_path_hides')){
                        document.getElementsByTagName('head')[0].appendChild(e)
                    }
                    requestAnimationFrame(t)
                }
            }
        }
        t()
    })()
    `;
    document.head.appendChild(scriptvwo);
    document.head.appendChild(linkvwo);
}

        

        return () => {
            /* this will be called when the component unmounts, also only once.  you could use this to dispose/clean up any resources you allocated in the outer body */
        };
    }, []);

    return (

          <UTMContext.Provider value={{ utmStorageSet, setUtmStorage }}>
            <AppContextWrapper>
                <Component {...pageProps} err={err} />
            </AppContextWrapper>
          </UTMContext.Provider>

    );
}

export default App;
